var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExitToApp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "locyw5h97a",
    d: "M10.51 16.24l1.47 1.468 5.207-5.208-5.208-5.208L10.51 8.76l2.688 2.698H3.125v2.084h10.073L10.51 16.24zm9.282-13.115H5.208c-1.156 0-2.083.938-2.083 2.083v4.167h2.083V5.208h14.584v14.584H5.208v-4.167H3.125v4.167c0 1.145.927 2.083 2.083 2.083h14.584c1.145 0 2.083-.938 2.083-2.083V5.208c0-1.146-.938-2.083-2.083-2.083z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-79 -25) translate(79 25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "jued22ug7b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#locyw5h97a"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#jued22ug7b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H52.083V52.083H0z",
    transform: "translate(-13.542 -13.542)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExitToApp);
export default __webpack_public_path__ + "static/media/ic-exit-to-app.0a49202ffaacc63801d8c2a81e12cb55.svg";
export { ForwardRef as ReactComponent };